// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file user_confirmation_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { UserConfirmationData } from "./user_confirmation_data_pb";
import { file_user_confirmation_data } from "./user_confirmation_data_pb";
import type { UserConfirmationResultType } from "./user_confirmation_result_type_pb";
import { file_user_confirmation_result_type } from "./user_confirmation_result_type_pb";
import type { SyncUpdate } from "./sync_update_pb";
import { file_sync_update } from "./sync_update_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file user_confirmation_service.proto.
 */
export const file_user_confirmation_service: GenFile = /*@__PURE__*/
  fileDesc("Ch91c2VyX2NvbmZpcm1hdGlvbl9zZXJ2aWNlLnByb3RvEgZkb21haW4iSwodQ3JlYXRlVXNlckNvbmZpcm1hdGlvblJlcXVlc3QSKgoEZGF0YRgBIAEoCzIcLmRvbWFpbi5Vc2VyQ29uZmlybWF0aW9uRGF0YSJ0Ch5DcmVhdGVVc2VyQ29uZmlybWF0aW9uUmVzcG9uc2USJwoLc3luY191cGRhdGUYASABKAsyEi5kb21haW4uU3luY1VwZGF0ZRIKCgJpZBgCIAEoCRIdChV3ZWJhdXRobl9vcHRpb25zX2pzb24YAyABKAkiKAoaR2V0VXNlckNvbmZpcm1hdGlvblJlcXVlc3QSCgoCaWQYASABKAkigQEKG0dldFVzZXJDb25maXJtYXRpb25SZXNwb25zZRIdChVyZXF1ZXN0aW5nX3Nlc3Npb25faWQYASABKAkSKgoEZGF0YRgCIAEoCzIcLmRvbWFpbi5Vc2VyQ29uZmlybWF0aW9uRGF0YRIXCg9mYWxsYmFja19zdHJpbmcYAyABKAkigQEKIVNlbmRVc2VyQ29uZmlybWF0aW9uUmVzdWx0UmVxdWVzdBIKCgJpZBgBIAEoCRIwCgR0eXBlGAIgASgOMiIuZG9tYWluLlVzZXJDb25maXJtYXRpb25SZXN1bHRUeXBlEh4KFndlYmF1dGhuX3Jlc3BvbnNlX2pzb24YAyABKAkiTQoiU2VuZFVzZXJDb25maXJtYXRpb25SZXN1bHRSZXNwb25zZRInCgtzeW5jX3VwZGF0ZRgBIAEoCzISLmRvbWFpbi5TeW5jVXBkYXRlIjMKJVJldHJpZXZlVXNlckNvbmZpcm1hdGlvblJlc3VsdFJlcXVlc3QSCgoCaWQYASABKAkiYQomUmV0cmlldmVVc2VyQ29uZmlybWF0aW9uUmVzdWx0UmVzcG9uc2USNwoLcmVzdWx0X3R5cGUYASABKA4yIi5kb21haW4uVXNlckNvbmZpcm1hdGlvblJlc3VsdFR5cGUiKwodQ2FuY2VsVXNlckNvbmZpcm1hdGlvblJlcXVlc3QSCgoCaWQYASABKAkiSQoeQ2FuY2VsVXNlckNvbmZpcm1hdGlvblJlc3BvbnNlEicKC3N5bmNfdXBkYXRlGAEgASgLMhIuZG9tYWluLlN5bmNVcGRhdGUy+wMKF1VzZXJDb25maXJtYXRpb25TZXJ2aWNlElkKBkNyZWF0ZRIlLmRvbWFpbi5DcmVhdGVVc2VyQ29uZmlybWF0aW9uUmVxdWVzdBomLmRvbWFpbi5DcmVhdGVVc2VyQ29uZmlybWF0aW9uUmVzcG9uc2UiABJQCgNHZXQSIi5kb21haW4uR2V0VXNlckNvbmZpcm1hdGlvblJlcXVlc3QaIy5kb21haW4uR2V0VXNlckNvbmZpcm1hdGlvblJlc3BvbnNlIgASZQoKU2VuZFJlc3VsdBIpLmRvbWFpbi5TZW5kVXNlckNvbmZpcm1hdGlvblJlc3VsdFJlcXVlc3QaKi5kb21haW4uU2VuZFVzZXJDb25maXJtYXRpb25SZXN1bHRSZXNwb25zZSIAEnEKDlJldHJpZXZlUmVzdWx0Ei0uZG9tYWluLlJldHJpZXZlVXNlckNvbmZpcm1hdGlvblJlc3VsdFJlcXVlc3QaLi5kb21haW4uUmV0cmlldmVVc2VyQ29uZmlybWF0aW9uUmVzdWx0UmVzcG9uc2UiABJZCgZDYW5jZWwSJS5kb21haW4uQ2FuY2VsVXNlckNvbmZpcm1hdGlvblJlcXVlc3QaJi5kb21haW4uQ2FuY2VsVXNlckNvbmZpcm1hdGlvblJlc3BvbnNlIgBCMFouZ2l0bGFiLmNvbS9jb3RlY2hkZS9tb25vcmVwby9iYWNrZW5kL2RvbWFpbi9wYmIGcHJvdG8z", [file_user_confirmation_data, file_user_confirmation_result_type, file_sync_update]);

/**
 * @generated from message domain.CreateUserConfirmationRequest
 */
export type CreateUserConfirmationRequest = Message<"domain.CreateUserConfirmationRequest"> & {
  /**
   * @generated from field: domain.UserConfirmationData data = 1;
   */
  data?: UserConfirmationData | undefined;
};

/**
 * Describes the message domain.CreateUserConfirmationRequest.
 * Use `create(CreateUserConfirmationRequestSchema)` to create a new message.
 */
export const CreateUserConfirmationRequestSchema: GenMessage<CreateUserConfirmationRequest> = /*@__PURE__*/
  messageDesc(file_user_confirmation_service, 0);

/**
 * @generated from message domain.CreateUserConfirmationResponse
 */
export type CreateUserConfirmationResponse = Message<"domain.CreateUserConfirmationResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * Optional, sent when user has a security key
   *
   * @generated from field: string webauthn_options_json = 3;
   */
  webauthnOptionsJson: string;
};

/**
 * Describes the message domain.CreateUserConfirmationResponse.
 * Use `create(CreateUserConfirmationResponseSchema)` to create a new message.
 */
export const CreateUserConfirmationResponseSchema: GenMessage<CreateUserConfirmationResponse> = /*@__PURE__*/
  messageDesc(file_user_confirmation_service, 1);

/**
 * @generated from message domain.GetUserConfirmationRequest
 */
export type GetUserConfirmationRequest = Message<"domain.GetUserConfirmationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message domain.GetUserConfirmationRequest.
 * Use `create(GetUserConfirmationRequestSchema)` to create a new message.
 */
export const GetUserConfirmationRequestSchema: GenMessage<GetUserConfirmationRequest> = /*@__PURE__*/
  messageDesc(file_user_confirmation_service, 2);

/**
 * @generated from message domain.GetUserConfirmationResponse
 */
export type GetUserConfirmationResponse = Message<"domain.GetUserConfirmationResponse"> & {
  /**
   * @generated from field: string requesting_session_id = 1;
   */
  requestingSessionId: string;

  /**
   * @generated from field: domain.UserConfirmationData data = 2;
   */
  data?: UserConfirmationData | undefined;

  /**
   * @generated from field: string fallback_string = 3;
   */
  fallbackString: string;
};

/**
 * Describes the message domain.GetUserConfirmationResponse.
 * Use `create(GetUserConfirmationResponseSchema)` to create a new message.
 */
export const GetUserConfirmationResponseSchema: GenMessage<GetUserConfirmationResponse> = /*@__PURE__*/
  messageDesc(file_user_confirmation_service, 3);

/**
 * @generated from message domain.SendUserConfirmationResultRequest
 */
export type SendUserConfirmationResultRequest = Message<"domain.SendUserConfirmationResultRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: domain.UserConfirmationResultType type = 2;
   */
  type: UserConfirmationResultType;

  /**
   * Optional, if present allows web session to confirm its own operation with a webauthn response
   *
   * @generated from field: string webauthn_response_json = 3;
   */
  webauthnResponseJson: string;
};

/**
 * Describes the message domain.SendUserConfirmationResultRequest.
 * Use `create(SendUserConfirmationResultRequestSchema)` to create a new message.
 */
export const SendUserConfirmationResultRequestSchema: GenMessage<SendUserConfirmationResultRequest> = /*@__PURE__*/
  messageDesc(file_user_confirmation_service, 4);

/**
 * @generated from message domain.SendUserConfirmationResultResponse
 */
export type SendUserConfirmationResultResponse = Message<"domain.SendUserConfirmationResultResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.SendUserConfirmationResultResponse.
 * Use `create(SendUserConfirmationResultResponseSchema)` to create a new message.
 */
export const SendUserConfirmationResultResponseSchema: GenMessage<SendUserConfirmationResultResponse> = /*@__PURE__*/
  messageDesc(file_user_confirmation_service, 5);

/**
 * @generated from message domain.RetrieveUserConfirmationResultRequest
 */
export type RetrieveUserConfirmationResultRequest = Message<"domain.RetrieveUserConfirmationResultRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message domain.RetrieveUserConfirmationResultRequest.
 * Use `create(RetrieveUserConfirmationResultRequestSchema)` to create a new message.
 */
export const RetrieveUserConfirmationResultRequestSchema: GenMessage<RetrieveUserConfirmationResultRequest> = /*@__PURE__*/
  messageDesc(file_user_confirmation_service, 6);

/**
 * @generated from message domain.RetrieveUserConfirmationResultResponse
 */
export type RetrieveUserConfirmationResultResponse = Message<"domain.RetrieveUserConfirmationResultResponse"> & {
  /**
   * @generated from field: domain.UserConfirmationResultType result_type = 1;
   */
  resultType: UserConfirmationResultType;
};

/**
 * Describes the message domain.RetrieveUserConfirmationResultResponse.
 * Use `create(RetrieveUserConfirmationResultResponseSchema)` to create a new message.
 */
export const RetrieveUserConfirmationResultResponseSchema: GenMessage<RetrieveUserConfirmationResultResponse> = /*@__PURE__*/
  messageDesc(file_user_confirmation_service, 7);

/**
 * @generated from message domain.CancelUserConfirmationRequest
 */
export type CancelUserConfirmationRequest = Message<"domain.CancelUserConfirmationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message domain.CancelUserConfirmationRequest.
 * Use `create(CancelUserConfirmationRequestSchema)` to create a new message.
 */
export const CancelUserConfirmationRequestSchema: GenMessage<CancelUserConfirmationRequest> = /*@__PURE__*/
  messageDesc(file_user_confirmation_service, 8);

/**
 * @generated from message domain.CancelUserConfirmationResponse
 */
export type CancelUserConfirmationResponse = Message<"domain.CancelUserConfirmationResponse"> & {
  /**
   * @generated from field: domain.SyncUpdate sync_update = 1;
   */
  syncUpdate?: SyncUpdate | undefined;
};

/**
 * Describes the message domain.CancelUserConfirmationResponse.
 * Use `create(CancelUserConfirmationResponseSchema)` to create a new message.
 */
export const CancelUserConfirmationResponseSchema: GenMessage<CancelUserConfirmationResponse> = /*@__PURE__*/
  messageDesc(file_user_confirmation_service, 9);

/**
 * @generated from service domain.UserConfirmationService
 */
export const UserConfirmationService: GenService<{
  /**
   * errors:
   * - BadRequest (10400): user confirmation data is invalid
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - Internal (10500)
   *
   * @generated from rpc domain.UserConfirmationService.Create
   */
  create: {
    methodKind: "unary";
    input: typeof CreateUserConfirmationRequestSchema;
    output: typeof CreateUserConfirmationResponseSchema;
  },
  /**
   * errors:
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - UserConfirmationNotFound (120400)
   * - Internal (10500)
   *
   * @generated from rpc domain.UserConfirmationService.Get
   */
  get: {
    methodKind: "unary";
    input: typeof GetUserConfirmationRequestSchema;
    output: typeof GetUserConfirmationResponseSchema;
  },
  /**
   * Restricted to authenticator sessions, unless called with webauthn_credential_data filled.
   * errors:
   * - BadRequest (10400): invalid result type was sent, or by session that is not self unlocking
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - UserConfirmationNotFound (120400)
   * - Internal (10500)
   *
   * @generated from rpc domain.UserConfirmationService.SendResult
   */
  sendResult: {
    methodKind: "unary";
    input: typeof SendUserConfirmationResultRequestSchema;
    output: typeof SendUserConfirmationResultResponseSchema;
  },
  /**
   * Restricted to session which created the UserConfirmation. Calling this endpoint clears the
   * UserConfirmation on the backend as well.
   * errors:
   * - BadRequest (10400): user confirmation did not have a result yet, or did not belong to session
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - UserConfirmationNotFound (120400)
   * - Internal (10500)
   *
   * @generated from rpc domain.UserConfirmationService.RetrieveResult
   */
  retrieveResult: {
    methodKind: "unary";
    input: typeof RetrieveUserConfirmationResultRequestSchema;
    output: typeof RetrieveUserConfirmationResultResponseSchema;
  },
  /**
   * Restricted to session which created the UserConfirmation. This endpoint is idempotent, and
   * returns success if a confirmation was already cancelled or resolved.
   * errors:
   * - BadRequest (10400): user confirmation did not belong to session
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - Internal (10500)
   *
   * @generated from rpc domain.UserConfirmationService.Cancel
   */
  cancel: {
    methodKind: "unary";
    input: typeof CancelUserConfirmationRequestSchema;
    output: typeof CancelUserConfirmationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_user_confirmation_service, 0);

